import { render } from "./loadingpage.vue?vue&type=template&id=3d0fe5b1"
import script from "./loadingpage.vue?vue&type=script&lang=js"
export * from "./loadingpage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__